import { Icon } from 'antd';
import React from 'react';
import { Collapse,Row,Col,Card } from 'antd';
import 'antd/dist/antd.css';
//import YouTube from 'react-youtube';
const { Panel } = Collapse;


const UserStory = () => {

  const genExtra = () => (
    <Icon
      type="setting"
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  );

  return (
    <>
      <Collapse
        defaultActiveKey={['1','2']}>
        {/* <p>
            if there is any queires please contact in support@amshuhu.com
        </p> */}
        <Panel header={<strong>What is TaxRecon? </strong>} key="1" extra={genExtra()}>
          <div>
          <p> 
            <ul>
                <li>The TaxRecon is a Software built for businesses to deal with invoicing, gst filing, reconciling purchases with supplier data, availing accurate ITC (tax credit), inventory, accounting needs and much more!</li>
                <br/>
                <li> The goal is to make a businessman’s daily routine less tiring and let them focus more on growing their business, less on paperwork.</li>
            </ul>
          </p>
          </div>
        </Panel>
        <Panel header={<strong>Why use TaxRecon? </strong> } key="2" extra={genExtra()}>
        <div>
          <p> 
            <ul>
                <li>
                    TaxRecon enables complete GST compliance and increases cash flow for small and medium businesses, at the click of a few buttons, file gst returns easily and accurately, reconcile input tax credit smartly to unlock unutilised credit and navigate smoothly through clear and uncomplicated user interface.
                </li>
                <br/>
                <li> The goal is to make a businessman’s daily routine less tiring and let them focus more on growing their business, less on paperwork.</li>
                <br/>
                <li>Smart reconciliation.</li>
                <br/>
                <li>File returns easily and accurately.</li>
                <br/>
                <li>Maximize ITC and improve cash flow.</li>
                <br/>
                <li>Smart reports and notifications</li>
                <br/>
                <li>Integrated approach </li>
            </ul>
          </p>
          </div>
        </Panel>
        <Panel header={<strong>Dashboard</strong>} key="3" extra={genExtra()}>
     
        <Row>
          <Col span={12}>   
            
            <div style={{ width: '90%' }}>
              <br/>
                <ul>

                    <li>This dashboard displays the archives for Return filing status obtained from GSTN (Goods and Services Tax Network). It presents the following information for each entry</li>
                    <br/>

                    <li>ARN (Application Reference Number): The unique reference number assigned to each return filing application.</li>
                    <br/>

                    <li>Return Type: The type or category of the return being filed (e.g., GSTR-1, GSTR-3B, etc.).</li>
                    <br/>

                    <li>Financial Year: The specific financial year to which the return relates.</li>
                    <br/>

                    <li>This dashboard provides a comprehensive view of the historical return filing status for easier tracking and reference.</li>

                    <br/>   
                </ul>
            </div>
          </Col>

 
          {/* <Col span={10} style={{ width: '47%', height: '47%', borderRadius:"10%" }}>
            <div className="video-container" style={{ borderRadius: '10px', marginTop:"23px" }}>
              <YouTube videoId="hLcTGlDg1W01" />
            </div>
          </Col> */}

            <Col span={10} style={{ width: '49%', height: '47%'}}>
              <div className="video-container" style={{ borderRadius: '10px', marginTop: "15px" }}>
                <video borderRadius= "10px" width="600" height="360" controls>
                  <source src='https://taxrecon.s3.ap-southeast-1.amazonaws.com/videos/Dashboard.mp4' type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
          </Row>
        </Panel>
        <Panel header={<strong>Adding a new company </strong>} key="4" extra={genExtra()}>
     
     <Row>
          <Col span={12}>   
            
            <div style={{ width: '90%' }}>
              <br/>
                <ul>

                    <li>Once the dashboard is logged In the user should click on the <b>Company</b> module to add a number of companies for which gst compliance is needed.</li>
                    <br/>

                    <li>Once you have added the company, click on the "Users" button. In this section, you will find two different types of users: Admin and Reviewer.</li>
                    <br/>

                    <li>The Admin user has full access to the entered applications and can make changes or modifications as needed. They have both read and write permissions.</li>
                    <br/>

                    <li>On the other hand, the Reviewer user has read-only permissions. They can view the entered applications but cannot make any modifications or changes to them.</li>
                    <br/>

                    <li>Please assign the appropriate user type (Admin or Reviewer) based on the required access level.</li>

                    <br/>   
                </ul>
            </div>
          </Col>

          <Col span={10} style={{ width: '49%', height: '47%'}}>
              <div className="video-container" style={{ borderRadius: '10px', marginTop: "15px" }}>
                <video borderRadius= "10px" width="600" height="360" controls>
                  <source src='https://taxrecon.s3.ap-southeast-1.amazonaws.com/videos/Add_Company.mp4' type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>

          </Row>
        </Panel>
        <Panel header={<strong>Sales Register</strong>} key="6" extra={genExtra()}>
         <Row>
       <Col span={12}>   
         
         <div style={{ width: '90%' }}>
           <br/>
           <ul>
            <li>iSteer TaxRecon enables easy uploading of all your sales data from your CRM or your tally software or iSteer GST can also pull your sales data from GSTN. You can file GST returns for all types of Sales and receipts including B2B, B2CL, B2CS, CDNR, Exports, HSN etc.
            </li>
            <br/>
            <li> You can file GST returns for all types of Sales and receipts including B2B, B2CL, B2CS, CDNR, Exports, HSN etc.
            </li>
            <br/>
            <li>You can then preview GSTR1 and file your GSTR 1 from iSteer GST directly. The preview will also include the summary level details of GSTR1. After previewing GSTR1.</li>
            <br/>
            <li> you can save GSTR1 directly to GSTN from iSteer GST and can also submit the GSTR1 to GSTN.</li>
            <br/>
        </ul> 
         </div>
       </Col>
       <Col span={10} style={{ width: '49%', height: '47%'}}>
              <div className="video-container" style={{ borderRadius: '10px', marginTop: "15px" }}>
                <video borderRadius= "10px" width="600" height="360" controls>
                  <source src='https://taxrecon.s3.ap-southeast-1.amazonaws.com/videos/Sales_Register.mp4' type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>

         </Row>
        </Panel>
        <Panel header={<strong>Purchase Register</strong>} key="11" extra={genExtra()}>
     
        <Row>
          <Col span={12}>   
            
            <div style={{ width: '90%' }}>
              <br/>
              <ul>
               <li>TaxRecon enables easy uploading of all your purchase data from your CRM or Tally software. You can upload various types of purchases B2B, B2CL, B2CS, CDNR, exports, and HSN, ensuring comprehensive data coverage.
               </li>
              <br/>

              <li>You can upload various types of purchases B2B, B2CL, B2CS, CDNR, exports, and HSN, ensuring comprehensive data coverage.
               </li>
              <br/>

              <li>You can download the purchase template file from the 'Download Templates' section as a reference. Fill in your purchase details accurately in the template.
               </li>
              <br/>
              <li>Additionally, it allows for the retrieval of your purchase data (GSTR2A and GSTR2B) from GSTN</li>
              <br/>
            </ul>
            </div>
          </Col>
          <Col span={10} style={{ width: '49%', height: '47%'}}>
              <div className="video-container" style={{ borderRadius: '10px', marginTop: "15px" }}>
                <video borderRadius= "10px" width="600" height="360" controls>
                  <source src='https://taxrecon.s3.ap-southeast-1.amazonaws.com/videos/Purchase_Register.mp4' type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>

          </Row>
        </Panel>
        <Panel header={<strong>Smart Reconcile</strong>} key="7" extra={genExtra()}>
        
        <Row>
          <Col span={12}>   
            
            <div style={{ width: '90%' }}>
              <br/>
              <ul>
                <li>GST reconciliation between your purchases and your suppliers sales returns (GSTR 2B) will be done accurately using TaxRecon.
                </li>
                <br/>
                <li>iSteer TaxRecon enables easy uploading of all your purchase data from your CRM or your tally software and iSteer TaxRecon pulls your GSTR 2B from Government of India’s Goods and services tax network (GSTN) at the click of a button.</li>
                <br/>
                <li>When you click on the Reconcile button, iSteerGST matches your purchase with GSTR 2B and all mismatches are highlighted. Missing GSTR 2B data and missing purchase register data are also be highlighted. These enable you to take required action (notifying your suppliers or rectifying your purchase data) thereby maximizing your Input tax credit.</li>
                <br/>
              </ul>
            </div>
          </Col>
          <Col span={10} style={{ width: '49%', height: '47%'}}>
              <div className="video-container" style={{ borderRadius: '10px', marginTop: "15px" }}>
                <video borderRadius= "10px" width="600" height="360" controls>
                  <source src='https://taxrecon.s3.ap-southeast-1.amazonaws.com/videos/Reconcile.mp4' type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>

          </Row>
        </Panel>
        <Panel header={<strong>Input Credit Tax(ITC)</strong>} key="8" extra={genExtra()}>
        <Row>
        <Col span={12}>   
          
          <div style={{ width: '90%' }}>
            <br/>
            <ul>
            <br/>
            <li>iSteer TaxRecon pulls GSTR 3B and GSTR 2B data from GSTN and generates a complete report of ITC. iSteer GST compares the input tax credit available in GSTR 2B and the credit claimed in GSTR 3B and reports mismatches, if any.</li>
            <br/>

            <li>The ITC data for all the monthly GST return filings since July 2017 till date is drawn and mismatches for each month is calculated. Mismatches are in negative when you haven’t claimed ITC to the extent available in GSTR 2B. Mismatches from the months where ITC claims were done in excess or the positive mismatches are highlighted in Red.</li>
            <br/>

            <li>The total of all the months data from GSTR 3B and GSTR 2B are calculated and the cumulative mismatch since July 2017 is shown in the Total column. And this cumulative mismatch indicates the total ITC claimed in excess or the total ITC which was eligible for claim but not claimed.</li>
            <br/>

          </ul>
          </div>
        </Col>
        <Col span={10} style={{ width: '49%', height: '47%'}}>
              <div className="video-container" style={{ borderRadius: '10px', marginTop: "15px" }}>
                <video borderRadius= "10px" width="600" height="360" controls>
                  <source src='https://taxrecon.s3.ap-southeast-1.amazonaws.com/videos/ITC.mp4' type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>

        </Row>
        </Panel>  
        <Panel header={<strong>Return Filling Trends</strong>} key="9" extra={genExtra()}>
        <Row>
        <Col span={12}>   
          
          <div style={{ width: '90%' }}>
            <br/>
            <ul>
              <li>Enter the GSTIN Number then Collecting Data from Suppliers and Customers: Analyzing Form Completion and Filing Trends (Delays Extending to Subsequent Months)</li>
              <br/>
              <li>Enter the gstn number to fetch the data, once the data is displayed the user can summarize the data</li>
              <br/>
              <li>The user could also view the Supplier invoices raised to a particular GSTN </li>
              <br/>
              <li>The user could also view the Customer invoices raised to a particular GSTN </li>
              <br/>
              <li>The user could also download the data to view in excel format </li>
              <br/>
            </ul>
          </div>
        </Col>
        <Col span={10} style={{ width: '49%', height: '47%'}}>
              <div className="video-container" style={{ borderRadius: '10px', marginTop: "15px" }}>
                <video borderRadius= "10px" width="600" height="360" controls>
                  <source src='https://taxrecon.s3.ap-southeast-1.amazonaws.com/videos/Return_Filing_Trends.mp4' type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>

        </Row>
        </Panel>
        <Panel header={<strong>GSTR-3B & GSTR-9</strong>} key="10" extra={genExtra()}>
        <Row>
        <Col span={12}>   

          <div style={{ width: '90%' }}>
            <br/>
            <ul>
              <li>Once you upload the purchase data, you can preview the GSTR3B. It will display summarized data of your 3B data,
including details of outward supplies and inward supplies liable for reverse charge. 
              </li>
              <br/>
              <li>it will provide information on inter-State supplies made to unregistered persons, composition taxable persons, and UIN holders.Clicking this button will save your GSTR3B information to the GST network, completing the filing process.</li>
              <br/>
              <li>GSTR-9 is an annual return that consolidates all the GST-related information filed in the monthly or quarterly returns (GSTR-1, GSTR-3B, etc.) for a particular financial year. </li>
              <br/>
              <li>It provides a comprehensive view of a taxpayer's business transactions, including supplies made, supplies received, taxes paid, and Input Tax Credit (ITC) availed during the year</li>
              <br/>
            </ul>
          </div>
        </Col>
        <Col span={10} style={{ width: '49%', height: '47%'}}>
              <div className="video-container" style={{ borderRadius: '10px', marginTop: "15px" }}>
                <video borderRadius= "10px" width="600" height="360" controls>
                  <source src='https://taxrecon.s3.ap-southeast-1.amazonaws.com/videos/GSTR-3B_GSTR-9.mp4' type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Col>
        </Row>
        </Panel>
      </Collapse>
    </>
  );
};

export default UserStory;
